export const TableData = {
  column1: [
    {
      linkTitle: 'Advisory Agreement',
      link: '/advisoryagreement/'
    },
    {
      linkTitle: 'Assurant Guide to Benefits',
      link: '/guidetobenefits/'
    },
    {
      linkTitle:
        'DriveWealth Cash Management Program Disclosure Statement – Bank Sweep',
      link:
        'https://legal.drivewealth.com/cash-management-program-disclosure-statement-bank-sweep?lang=en_US'
    },
    {
      linkTitle: 'DriveWealth General Customer Disclosures',
      link:
        'https://apps.drivewealth.com/disclosures/?ria=Greenlight%20Investment%20Advisors,%20LLC&sweepType=bank'
    },
    {
      linkTitle: 'DriveWealth Customer Account Agreement',
      link:
        'https://legal.drivewealth.com/customer-account-agreement?lang=en_US'
    },
    {
      linkTitle: 'DriveWealth Disclosures and Disclaimers',
      link: 'https://legal.drivewealth.com/disclosures-disclaimers?lang=en_US'
    },
    {
      linkTitle: 'DriveWealth Privacy Policy',
      link: 'https://legal.drivewealth.com/privacy-policy'
    },
    {
      linkTitle: 'DriveWealth Rule 14b-1(c) Disclosure',
      link:
        'https://apps.drivewealth.com/disclosures/?ria=Greenlight%20Investment%20Advisors,%20LLC&sweepType=bank'
    }
  ],
  column2: [
    {
      linkTitle: 'DriveWealth Terms of Use',
      link: 'https://legal.drivewealth.com/terms-of-use?lang=en_US'
    },
    {
      linkTitle: 'Greenlight Privacy Policy',
      link: '/privacy/'
    },
    {
      linkTitle: 'Form CRS',
      link:
        'https://assets.ctfassets.net/kztakymoy4eb/2klY2qEyD3Nrglirv0QaRi/87aa7a1d769e38009c6b8ce24f302cd3/Form_CRS.pdf'
    },
    {
      linkTitle: 'Greenlight Investment Advisors Form ADV',
      link:
        'https://assets.ctfassets.net/kztakymoy4eb/7jFv2V8Wo0LFp6tzx3kZps/334e2ca21b3eae8e1231f24aa18666be/Greenlight_Investment_Advisors_Form_ADV.pdf'
    },
    {
      linkTitle:
        'Greenlight Investment Advisors Terms of Service for Invest Account Services',
      link: '/greenlight-investment-advisors-terms-of-service/'
    },
    {
      linkTitle: 'Greenlight Terms of Service',
      link: '/terms-of-service/'
    },
    {
      linkTitle: 'Limited Power of Attorney and Fee Withdrawal Agreement',
      link:
        'https://apps.drivewealth.com/disclosures/?ria=Greenlight%20Investment%20Advisors,%20LLC&sweepType=bank'
    },
    {
      linkTitle: 'Morningstar Disclosures',
      link: '/morningstardisclosure/'
    },
    {
      linkTitle: 'Wrap Fee Brochure',
      link:
        'https://assets.ctfassets.net/kztakymoy4eb/6KBDbRBFAs31lMYW317Edg/5db3817c7c175ced20fed65101204766/Wrap_Fee_Brochure.pdf'
    }
  ]
};
